import { takeLatest, put } from 'redux-saga/effects';
import { getRequest } from '../../../../utilities/requests';
import {
  setMerchantApplicationProcessingVolume,
  LOAD_MERCHANT_APPLICATION
} from './reducer';

function* handleLoadMerchantApplicationProcessingVolume() {
  const url = '/processing_volumes';
  const response = yield getRequest(url);
  yield put(
    setMerchantApplicationProcessingVolume(response.data.processing_volumes)
  );
}

export function* loadMerchantApplicationSaga() {
  yield takeLatest(
    LOAD_MERCHANT_APPLICATION,
    handleLoadMerchantApplicationProcessingVolume
  );
}
